import * as identityProviders from '../services/IdentityProviders'

export const RECEIVE_IDENTITY_PROVIDERS = 'RECEIVE_IDENTITY_PROVIDERS'

function receiveIdentityProviders(state, identityProviders) {
  return {
    type: RECEIVE_IDENTITY_PROVIDERS,
    identityProviders
  }
}

export const fetchIdentityProviders = () => (dispatch, getState) => {
  const state = getState()
  let subsidiaryId = state.currentUser.subsidiary
  identityProviders.getBySubsidiaryId(subsidiaryId).then((data) => dispatch(receiveIdentityProviders(state, data)))
}

export const fetchIdentityProvidersFor = (id) => (dispatch, getState) => {
  identityProviders.getBySubsidiary(id).then( (data) => dispatch(receiveIdentityProviders(getState(), data)))
}
